import React, { PropsWithChildren } from 'react';

export function createStorageProvider<T extends object>(defaultValues: T) {
  const StorageContext = React.createContext<T>(defaultValues);

  const StorageProvider: React.FC<PropsWithChildren<T>> = (props) => {
    return (
      <StorageContext.Provider value={props}>
        {props.children}
      </StorageContext.Provider>
    );
  };

  const withStorageProvider = (ProvidedComponent: React.FC<any>) => {
    return (props: Partial<T>) => {
      const merged: T = { ...defaultValues, ...props };

      return (
        <StorageProvider {...merged}>
          <ProvidedComponent />
        </StorageProvider>
      );
    };
  };

  const useStorage = (): T => {
    return React.useContext(StorageContext);
  };

  return {
    withStorageProvider,
    useStorage,
  };
}
